import { atom } from "jotai";
import { Store, STORE_KEY, Theme } from "../Store";

export enum ViewState {
  STRIPPED = "stripped",
  DEFAULT = "default",
}

export const themeState = atom<Theme>(Store.getValue(STORE_KEY.STORE_THEME));

export const viewState = atom<ViewState>(ViewState.DEFAULT);

export const contractSidebarState = atom<boolean>(false);
